<template>
  <div class="resume-yearly">
    <div class="resume-yearly__tabs">
      <div
        class="resume-yearly__tab"
        @click="currentTable='Gastos'"
        :class="{'tab-selected':currentTable=='Gastos'}"
      >Gastos en empleados</div>
      <div
        class="resume-yearly__tab"
        @click="currentTable='Descuentos'"
        :class="{'tab-selected':currentTable=='Descuentos'}"
      >Descuentos en empleados</div>
    </div>
    <transition name="fade" mode="out-in">
      <md-table
        v-model="searchedComp"
        md-sort="firstSurname"
        md-sort-order="asc"
        md-card
        v-if="currentTable=='Gastos'"
      >
        <md-table-toolbar>
          <h1 class="md-title">Resumen Anual de Gastos (Proyección)</h1>
          <md-field md-clearable class="md-toolbar-section-end">
            <md-input placeholder="Busca por apellido..." v-model="search" @input="searchOnTable" />
          </md-field>
        </md-table-toolbar>

        <md-table-empty-state
          md-label="No se encontraron registros"
          :md-description="`No se encontró ningún empledo para la busqueda con '${search}'. Intenta una nueva busqueda o crea al empleado que buscas.`"
        >
          <md-button
            class="md-primary md-raised"
            @click="this.$router.push({name: 'T-Registros'})"
          >Crea al Empleado</md-button>
        </md-table-empty-state>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Empleado" md-sort-by="firstSurname" class="header-cell-empleado">
            <p class="fullname">{{ item.firstSurname }}, {{ item.firstName }}</p>
          </md-table-cell>
          <md-table-cell md-label="Enero" md-sort-by="jan">
            <p class="nowrap">{{ item.jan | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Febrero" md-sort-by="feb">
            <p class="nowrap">{{ item.feb | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Marzo" md-sort-by="mar">
            <p class="nowrap">{{ item.mar | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Abril" md-sort-by="apr">
            <p class="nowrap">{{ item.apr | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Mayo" md-sort-by="may">
            <p class="nowrap">{{ item.may | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Junio" md-sort-by="jun">
            <p class="nowrap">{{ item.jun | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Julio" md-sort-by="jul">
            <p class="nowrap">{{ item.jul | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Agosto" md-sort-by="ago">
            <p class="nowrap">{{ item.ago | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Septiembre" md-sort-by="set">
            <p class="nowrap">{{ item.set | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Octubre" md-sort-by="oct">
            <p class="nowrap">{{ item.oct | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Noviembre" md-sort-by="nov">
            <p class="nowrap">{{ item.nov | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Diciembre" md-sort-by="dec">
            <p class="nowrap">{{ item.dec | currency }}</p>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <md-table v-model="searchedComp" md-sort="firstSurname" md-sort-order="asc" md-card v-else>
        <md-table-toolbar>
          <h1 class="md-title">Resumen Anual de Descuentos (Proyección)</h1>
          <md-field md-clearable class="md-toolbar-section-end">
            <md-input placeholder="Busca por apellido..." v-model="search" @input="searchOnTable" />
          </md-field>
        </md-table-toolbar>

        <md-table-empty-state
          md-label="No se encontraron registros"
          :md-description="`No se encontró ningún empledo para la busqueda con '${search}'. Intenta una nueva busqueda o crea al empleado que buscas.`"
        >
          <md-button
            class="md-primary md-raised"
            @click="this.$router.push({name: 'T-Registros'})"
          >Crea al Empleado</md-button>
        </md-table-empty-state>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Empleado" md-sort-by="firstSurname" class="header-cell-empleado">
            <p class="fullname">{{ item.firstSurname }}, {{ item.firstName }}</p>
          </md-table-cell>
          <md-table-cell md-label="Enero" md-sort-by="jan">
            <p class="nowrap">{{ item.jan | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Febrero" md-sort-by="feb">
            <p class="nowrap">{{ item.feb | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Marzo" md-sort-by="mar">
            <p class="nowrap">{{ item.mar | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Abril" md-sort-by="apr">
            <p class="nowrap">{{ item.apr | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Mayo" md-sort-by="may">
            <p class="nowrap">{{ item.may | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Junio" md-sort-by="jun">
            <p class="nowrap">{{ item.jun | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Julio" md-sort-by="jul">
            <p class="nowrap">{{ item.jul | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Agosto" md-sort-by="ago">
            <p class="nowrap">{{ item.ago | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Septiembre" md-sort-by="set">
            <p class="nowrap">{{ item.set | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Octubre" md-sort-by="oct">
            <p class="nowrap">{{ item.oct | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Noviembre" md-sort-by="nov">
            <p class="nowrap">{{ item.nov | currency }}</p>
          </md-table-cell>
          <md-table-cell md-label="Diciembre" md-sort-by="dec">
            <p class="nowrap">{{ item.dec | currency }}</p>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </transition>
  </div>
</template>

<script>
export default {
  // props: ["users"],
  name: "ResumeMonthly",
  data() {
    return {
      search: null,
      searched: [],
      currentTable: "Gastos"
    };
  },
  beforeCreate() {
    this.$store.dispatch("summaryYear", this.$localStorage.get("businessID"));
  },
  created() {
    this.searched = this.summary;
  },
  computed: {
    summary: {
      get() {
        return this.$store.getters.summaryByYear;
      },
      set(val) {
        this.$store.commit("SET_SUMMARY_YEAR", val);
      }
    },
    searchedComp: {
      get() {
        if (!this.searched.length && !this.search) {
          this.searched = this.summary;
        }
        return this.searched;
      },
      set(val) {
        this.searched = val;
      }
    }
  },
  methods: {
    searchOnTable() {
      if (this.search) {
        console.log(
          this.summary.filter(item =>
            item.firstSurname.toLowerCase().includes(this.search.toLowerCase())
          )
        );

        this.searched = this.summary.filter(item =>
          item.firstSurname.toLowerCase().includes(this.search.toLowerCase())
        )
          ? this.summary.filter(item =>
              item.firstSurname
                .toLowerCase()
                .includes(this.search.toLowerCase())
            )
          : [];
      } else {
        this.searched = this.summary;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;

$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;

@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}
.cell-table-empleado {
  text-align: start;
}
.cell-table-numeric {
  text-align: end;
}
.nowrap {
  white-space: nowrap;
}
.fullname {
  min-width: 155px;
}
.resume-yearly {
  height: calc(100vh - 190px);
  overflow-y: scroll;
  &__tabs {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1rem;
    background-color: #fff;
    position: relative;
  }
  &__tab {
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    background-color: #e6e6e6;
    color: $b-blue-dark;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    @include mq($md) {
      cursor: pointer;
    }
  }
}
.tab-selected {
  background-color: #fff !important;
  font-weight: 700 !important;
  border: 1px solid rgba($b-orange, 0.75) !important;
  border-bottom: 1px solid #fff !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>